// src/hooks/useHierarchyInit.ts
// Fetches the officer-hierarchy role list once the user is authenticated and
// caches it in hierarchySlice — badges/pickers read it synchronously from there.

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { roleService } from 'services/roleService';
import { setRoles } from 'store/slices/hierarchySlice';

export function useHierarchyInit(): void {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((s: RootState) => s.auth);

  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelled = false;

    roleService.getAll().then((roles) => {
      if (!cancelled) dispatch(setRoles(roles));
    }).catch(() => { /* non-fatal — badges fall back to raw role name */ });

    return () => { cancelled = true; };
  }, [isAuthenticated, dispatch]);
}
